export const FETCH_PATIENTS_REQUEST = 'FETCH_PATIENTS_REQUEST';
export const FETCH_PATIENTS_SUCCESS = 'FETCH_PATIENTS_SUCCESS';
export const FETCH_PATIENTS_FAILURE = 'FETCH_PATIENTS_FAILURE';

export const CREATE_PATIENT_REQUEST = 'CREATE_PATIENT_REQUEST';
export const CREATE_PATIENT_SUCCESS = 'CREATE_PATIENT_SUCCESS';
export const CREATE_PATIENT_FAILURE = 'CREATE_PATIENT_FAILURE';

export const UPDATE_PATIENT_REQUEST = 'UPDATE_PATIENT_REQUEST';
export const UPDATE_PATIENT_SUCCESS = 'UPDATE_PATIENT_SUCCESS';
export const UPDATE_PATIENT_FAILURE = 'UPDATE_PATIENT_FAILURE';

export const DELETE_PATIENT_REQUEST = 'DELETE_PATIENT_REQUEST';
export const DELETE_PATIENT_SUCCESS = 'DELETE_PATIENT_SUCCESS';
export const DELETE_PATIENT_FAILURE = 'DELETE_PATIENT_FAILURE';

export const fetchPatientsRequest = (projectId, options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
      type: FETCH_PATIENTS_REQUEST,
      payload: { projectId, page, limit, search },
      
    };
    
  }; 
export const fetchPatientsSuccess = (patients) => ({ type: FETCH_PATIENTS_SUCCESS, payload: patients });
export const fetchPatientsFailure = (error) => ({ type: FETCH_PATIENTS_FAILURE, payload: error });

export const createPatientRequest = (data,projectId) => ({ type: CREATE_PATIENT_REQUEST, payload: {data,projectId} });
export const createPatientSuccess = (patient) => ({ type: CREATE_PATIENT_SUCCESS, payload: patient });
export const createPatientFailure = (error) => ({ type: CREATE_PATIENT_FAILURE, payload: error });

export const updatePatientRequest = (id, data,projectId) => ({ type: UPDATE_PATIENT_REQUEST, payload: { id, data,projectId } });
export const updatePatientSuccess = (patient) => ({ type: UPDATE_PATIENT_SUCCESS, payload: patient });
export const updatePatientFailure = (error) => ({ type: UPDATE_PATIENT_FAILURE, payload: error });

export const deletePatientRequest = (projectId,id) => ({ type: DELETE_PATIENT_REQUEST, payload: {projectId,id} });
export const deletePatientSuccess = (id) => ({ type: DELETE_PATIENT_SUCCESS, payload: id });
export const deletePatientFailure = (error) => ({ type: DELETE_PATIENT_FAILURE, payload: error });
